<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <!--  <h1>접근 권한 안내</h1>-->
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <p>
                {{ title }}
              </p>
            </div>
            <ul class="modal-info-gray-area mt10">
              <li>
                <p class="title">인사이드</p>
                <p class="text">내부 추모관 (배경이미지: 이미지)</p>
              </li>
              <li>
                <p class="title">아웃사이드</p>
                <p class="text">외부 추모관 (배경이미지: 영상)</p>
              </li>
            </ul>
          </div>
          <BasicButton modal-btn single-text="등록 시작하기" @click="close" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import BasicButton from '@/components/common/layouts/BasicButton.vue';
const props = defineProps(['data']);
const emits = defineEmits(['close']);

const { fnCallBack, title, contents } = props.data;

const close = () => {
  if (fnCallBack) fnCallBack();
  emits('close');
};
</script>

<style scoped></style>
